import { useFormContext } from 'react-hook-form';
import { SVButton, SVFilePicker } from '../core';
import { Avatar } from '@mui/material';

type ProfileEditAvatarButtonProps = {
  uuid: string | null;
};

export default function ProfileEditAvatarButton({
  uuid,
}: ProfileEditAvatarButtonProps) {
  const formMethods = useFormContext();
  const avatarUrl = formMethods.watch('avatarUrl');
  const isUpload = avatarUrl === '';

  return (
    <>
      <Avatar
        sx={{ height: 160, width: 160, margin: '0 auto', mb: 2 }}
        src={avatarUrl}
      />
      {isUpload ? (
        <SVFilePicker
          label="Upload Avatar"
          name="avatarUrl"
          documentDisplayName="avatarDisplayName"
          presignedUrlFileType="profile avatar"
          uuid={uuid}
        />
      ) : (
        <SVButton
          onClick={() => {
            formMethods.setValue('avatarUrl', '');
            formMethods.setValue('avatarDisplayName', '');
          }}>
          Remove
        </SVButton>
      )}
    </>
  );
}
